/* RESPONSIBLE TEAM: team-inbox */
export const VALID_ACTION_TYPES = ['read', 'change', 'delete'];

export const AWAY_MODE_KEY = 'can_teammates__away_mode__change';
export const REPORTS_DELETE_KEY = 'can_reporting__reports__delete';
export const CHANGE_TICKET_TYPE_KEY = 'can_change_ticket_type';
